const TrendAnalysisConstants = {
  TITLE: 'Trend Analysis Metric Builder',
  // TABS: ['Date Selection', 'Metric Builder'],
  TABS: ['Metric Builder'],
  NO_DATE_FILTER: 'No filter on dates',
  SELECTED_RANGE: 'Selected Date Range',
  TIME_GRAIN: 'Time Grain',
  NO_DATE_SELECTED:
    'Kindly complete the date range selection in the previous step to proceed with the analysis.',
  SERIES_CONFIGURATION:
    'Series Configuration (Add one or more series to view the analysis)',
  PRIMARY_AXIS: 'Primary Y-Axis',
  SECONDARY_AXIS: 'Secondary Y-Axis',
  UNIT: 'Unit',
  CHART_TYPE: 'Chart Type',
  CHART_STYLE: 'Chart Style',
  CHART_TYPE_OPTIONS: [
    {
      type: 'Column',
      styles: ['Grouped Column', 'Stacked Column'],
    },
    {
      type: 'Bar',
      styles: ['Grouped Bar', 'Stacked Bar'],
    },
    {
      type: 'Line',
      styles: ['Dotted Line', 'Dashed Line', 'Solid Line'],
    },
    {
      type: 'Area',
      styles: ['Multi Series Area', 'Stacked Area'],
    },
  ],
  METRIC_TAXONOMY: 'Metric Taxonomy',
  METRIC: 'Metric',
  SUB_METRIC: 'Sub Metric',
  ADD_METRIC: 'Add Metric',
  ADD_SUB_METRIC: 'Add Sub Metric',
  VIEW_ANALYSIS: 'View Analysis',
  METRIC_FIELD_MAP: {
    'Total Cost of Care': 'total_paid_amount',
    'Plan Paid': 'total_plan_paid',
    'Member Paid': 'total_member_paid',
    'Medical Spend': 'med_total_paid',
    'Pharmacy Spend': 'rx_total_paid',
    'Rx Plan Paid': 'rx_plan_paid',
    'Rx Member Paid': 'rx_member_paid',
    'Medical Plan Paid': 'med_plan_paid',
    'Medical Member Paid': 'med_member_paid',
    'Total Claims(Medical + Rx)': 'claimsCount',
    'Medical Claims': 'medicalClaimsCount',
    'Rx Claims': 'rxClaimsCount',
    'Eligible Members': 'memberCount',
    'Subscribers/Employees': 'employeeCount',
    Dependents: 'dependentCount',
    'Per Member Per Month (PMPM)': 'pmpm',
    'Per Member Per Year (PMPY)': 'pmpy',
    'Per Employee Per Year (PEPY)': 'pepy',
    'Per Employee Per Month (PEPM)': 'pepm',
    'Cost Per 100 Members': 'costPer100Members',
    'Cost Per 1000 Members': 'costPer1000Members',
  },
  EDIT_ANALYSIS: 'Edit Analysis',
  EXPORT: 'Export As',
  EXPORT_OPTIONS: ['Pdf', 'Ppt', 'Csv'],
  EXPORT_VALUES: ['pdf', 'pptx', 'csv'],
  DEFAULT_PRIMARY_AXIS_DATA: {
    unit: 'Cost',
    chartType: 'Column',
    metrics: [
      {
        name: 'Overall Cost Trend',
        identifier: 'overall',
        options: [
          {
            name: 'Rx Plan Paid',
            color: '#ff8c8c',
          },
          {
            name: 'Rx Member Paid',
            color: '#94D1C7',
          },
          {
            name: 'Medical Plan Paid',
            color: '#9cb6fd',
          },
          {
            name: 'Medical Member Paid',
            color: 'cfdcff',
          },
        ],
      },
    ],
    chartStyle: 'Stacked Column',
  },
  DEFAULT_SECONDARY_AXIS_DATA: {
    unit: 'Claim Count',
    chartType: 'Line',
    metrics: [
      {
        name: 'Overall Claim Count',
        identifier: 'overall',
        options: [
          {
            name: 'Total Claims(Medical + Rx)',
            color: '#C9A267',
          },
        ],
      },
    ],
    chartStyle: 'Solid Line',
  },
  DEFAULT_TIME_GRAIN: 'Monthly',
  NEW: 'New Trend Analysis',
  NEW_TREND: 'Add Trend',
  TREND_NAME: 'Trend Name',
  CANCEL: 'Cancel',
  TREND_PLACEHOLDER: 'Enter Trend Name',
  TREND_PREVIEW: 'Preview Trend Analysis',
  CREATE_ANALYSIS: 'Create Analysis',
  UPDATE_ANALYSIS: 'Update Analysis',
};

export default TrendAnalysisConstants;
